import axios from "axios";
const url_api = process.env.REACT_APP_API_URL;
const institute_url_api= url_api+"/institute" 

const configureAxios={
    headers: {
      'content-Type': 'multipart/form-data'
    }
  }
  const configureAxioB={
    headers: {
      'content-Type': 'image/jpeg'
    }
  }
const InstituteService={
    getAllInstitutes: async()=>{
        try {
            const response= await axios.get(institute_url_api);
            return response;
        } catch (error) {
            return error;
        }
    },
    postInstitute: async(institute)=> {
        try {
            const response= await axios.post(institute_url_api+"/creationinstitute",institute);
            return response;
        } catch (error) {
            return error;
        }
    },
    updateInstitute: async(institute)=>{
        try {
            const instituteId=institute.id;
            const response= await axios.put(institute_url_api+"/updateinstitute/"+instituteId,institute);
            return response;
        } catch (error) {
            return error;   
        }

    },
    getInstituteById: async(instituteId)=>{
        try {
            const response= await axios.get(institute_url_api+"/getoneinstitute/"+instituteId);
            return response;
        } catch (error) {
            return error;
        }
    },
    deleteInstituteById: async(instituteId)=>{
        try {
            const response= await axios.delete(institute_url_api+"/deleteinstitute/"+instituteId);
            return response;
        } catch (error) {
            return error;
        }
    },
    getListInstitutesByRegister: async()=>{
        try {
            const response= await axios.get(institute_url_api+"/getlistinstitutes");
            return response;
        } catch (error) {
            return error;
        }
    },
    checkDataByInstituteForDeleted: async(instituteId)=>{
        try{
            const verification=await axios.get(institute_url_api+"/checkdatabyinstitute/"+instituteId)
            return verification;
        }catch(error){
            return error
        }
    },
    getInstituteDataByInstitute:async(instituteId)=>{
        try{
            const centerData=await axios.get(institute_url_api+"/"+instituteId+"/institutedata/")
            return centerData;
        }catch(error){
            return error
        }
    },
    createInstituteDataByCenter:async(instituteId,newInstituteData)=>{
        try{
            const centerData=await axios.post(institute_url_api+"/"+instituteId+"/institutedata/create",newInstituteData)
            return centerData;
        }catch(error){
            return error
        }
    },
    updateInstituteDataByInstitute:async(instituteId,newInstituteData)=>{
        try{
            const centerData=await axios.put(institute_url_api+"/"+instituteId+"/institutedata/update",newInstituteData)
            return centerData;
        }catch(error){
            return error
        }
    },
    transferToUserAnotherInstitute:async(userId,updateInstitute)=>{
        try {
            const centerData=await axios.put(institute_url_api+"/transfercenter/user/"+userId,updateInstitute)
            return centerData;
        } catch (error) {
            return error;
        }
    },
    createDocumentApproval:async(documentApproval,InstituteId,userId)=>{
        try {
            const documentApprovalCenter=await axios.post(url_api+"/institute/"+InstituteId+"/registerdocumentapprovalby/"+userId,documentApproval,configureAxios)
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },
    updateDocumentApproval:async(documentApproval,InstituteId,userId)=>{
        try {
            const documentApprovalCenter=await axios.put(url_api+"/institute/"+InstituteId+"/updatedocumentapprovalby/"+userId,documentApproval,configureAxios)
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },
    getDocumentApprovalByInstitute:async(InstituteId)=>{
        try {
            const documentApprovalCenter=await axios.get(url_api+"/institute/"+InstituteId+"/getdocumentapprovalbyinstitute/")
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },
    getOneInstituteInformationByCenter: async(centerID)=>{
        try {
            const response= await axios.get(institute_url_api+"/getoneinstitute/"+centerID);
            return response;
        } catch (error) {
            return error;
        }
    },

    updateLogoByInstitute:async(logoCenter,InstituteId)=>{
        try {
            console.log(logoCenter.get("logoInstitute"))
            const center=await axios.put(institute_url_api+"/"+InstituteId+"/updatelogo/",logoCenter,configureAxioB)
            return center;
        } catch (error) {
            return error;
        }
    },

    getLogoByInstitute:async(InstituteId)=>{
        try {
            const center=await axios.get(institute_url_api+"/imagelogoinstitute/"+InstituteId)
            return center;
        } catch (error) {
            return error;
        }
    },
}

export default InstituteService;